import React, {Component} from 'react';
import AppNavigation from './AppNavigation';
import AppFooter from './AppFooter';
import SubMyIdeas from './Subcomponents/MyIdeas';
import withRouter from './Functions/WithRouter';

class MyIdeas extends Component {
    constructor(props) {
      super(props)

      this.state = {
      }
    }

    componentDidMount() {
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

      let email = localStorage.getItem('email');
      const activeOrg = localStorage.getItem('activeOrg');
      const orgLogo = localStorage.getItem('orgLogo');

      this.setState({ emailId: email, activeOrg, orgLogo })
    }

    render() {

        return (
            <div>
                <AppNavigation username={this.state.username}  activeOrg={this.state.activeOrg} orgFocus={this.state.orgFocus}  history={this.props.navigate}/>

                <div className={"standard-container-2"}>
                  <SubMyIdeas history={this.props.navigate} />
                </div>

                {(this.state.activeOrg) && (
                  <div>
                    {AppFooter(this.props.navigate,this.state.activeOrg,this.state.orgLogo)}
                  </div>
                )}
            </div>

        )
    }
}

export default withRouter(MyIdeas)
